'use strict';

var $ = require('jquery');

/*@ngInject*/
module.exports = function($scope, $state, $translate, $filter, rssFeed) {
	//var feedPage = 1;
	var feedUrl = null;
	var feedCount = 3;

	var findFirstImage =  function(element) {
		var $img = $(element).find('img:first');
		if ($img.length > 0) {
			return $img.attr('src');
		}
		else {
			return '';
		}
	};
	var formatDate = function(dateString) {
		var date = new Date(dateString);
		var format = $translate.instant('templates.dateformat');
		return $filter('date')(date, format);
	};

	if ($state.current.data) {
		feedUrl = $state.current.data.feedUrl || feedUrl;
		feedCount = $state.current.data.feedCount || feedCount;
		//feedPage = $state.feedPage || feedPage;
	}

	// setup paging
	//feedUrl += "&paged=" + feedPage;
	feedUrl += "&count=" + feedCount;

	$scope.loadFeed = function() {
		if (feedUrl) {
			rssFeed.load(feedUrl, feedCount)
				.then(function(response) {
					$scope.entries = response.data.items;

					// format other variables
					for (var i = 0, len = $scope.entries.length; i < len; i++) {
						// get first image
						$scope.entries[i].image = findFirstImage($scope.entries[i].content);
						$scope.entries[i].contentSnippet = $scope.entries[i].description;
						// format date  yyyy-mm-dd hh:mm:ss, only get the day substring(0,10)
						$scope.entries[i].formattedDate = formatDate($scope.entries[i].pubDate.substring(0,10));					
					}
					rssFeed.setFeed($scope.entries);
				});
		}
	};

	$scope.entries = rssFeed.getFeed();
	if ($scope.entries.length === 0) {
		$scope.entries = [];
		$scope.loadFeed();
	}


};